/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardMessageRedactorRouteImport } from './routes/dashboard/message-redactor'
import { Route as DashboardJiraToolbeltRouteImport } from './routes/dashboard/jira-toolbelt'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardMessageRedactorRoute =
  DashboardMessageRedactorRouteImport.update({
    id: '/dashboard/message-redactor',
    path: '/dashboard/message-redactor',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardJiraToolbeltRoute = DashboardJiraToolbeltRouteImport.update({
  id: '/dashboard/jira-toolbelt',
  path: '/dashboard/jira-toolbelt',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/jira-toolbelt': typeof DashboardJiraToolbeltRoute
  '/dashboard/message-redactor': typeof DashboardMessageRedactorRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/jira-toolbelt': typeof DashboardJiraToolbeltRoute
  '/dashboard/message-redactor': typeof DashboardMessageRedactorRoute
  '/dashboard': typeof DashboardIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/jira-toolbelt': typeof DashboardJiraToolbeltRoute
  '/dashboard/message-redactor': typeof DashboardMessageRedactorRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard/jira-toolbelt'
    | '/dashboard/message-redactor'
    | '/dashboard/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/jira-toolbelt'
    | '/dashboard/message-redactor'
    | '/dashboard'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/dashboard/jira-toolbelt'
    | '/dashboard/message-redactor'
    | '/dashboard/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  DashboardJiraToolbeltRoute: typeof DashboardJiraToolbeltRoute
  DashboardMessageRedactorRoute: typeof DashboardMessageRedactorRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/message-redactor': {
      id: '/dashboard/message-redactor'
      path: '/dashboard/message-redactor'
      fullPath: '/dashboard/message-redactor'
      preLoaderRoute: typeof DashboardMessageRedactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/jira-toolbelt': {
      id: '/dashboard/jira-toolbelt'
      path: '/dashboard/jira-toolbelt'
      fullPath: '/dashboard/jira-toolbelt'
      preLoaderRoute: typeof DashboardJiraToolbeltRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  DashboardJiraToolbeltRoute: DashboardJiraToolbeltRoute,
  DashboardMessageRedactorRoute: DashboardMessageRedactorRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
